// extracted by mini-css-extract-plugin
export default {"toggle-switch":"Switch_toggle-switch__ZOiZ0","ant-switch-checked":"Switch_ant-switch-checked__gVcvp"};